import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-dutyfree-guest-picker',
  templateUrl: './dutyfree-guest-picker.component.html',
  styleUrls: ['./dutyfree-guest-picker.component.scss'],
})
export class DutyfreeGuestPickerComponent implements OnInit {
  @Input() userGuestList: any[] = [];
  @Input() guestType: string;

  public searchQuery = '';
  public guests: any[] = [];

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    const list = Array.isArray(this.userGuestList) ? this.userGuestList : [];
    this.guests = this.guestType
      ? list.filter(
          (item) =>
            String(item?.type || '').toLowerCase() ===
            this.guestType.toLowerCase()
        )
      : list;
  }

  get filteredGuests(): any[] {
    const query = this.searchQuery.trim().toLowerCase();
    if (!query) {
      return this.guests;
    }
    return this.guests.filter((guest) => {
      const haystack = [
        guest?.firstName,
        guest?.lastName,
        guest?.email,
        guest?.phoneNo,
        guest?.phoneNumber,
        guest?.nationality,
        guest?.passportNo,
      ]
        .map((part) => String(part || '').toLowerCase())
        .join(' ');
      return haystack.includes(query);
    });
  }

  guestName(guest: any): string {
    return [guest?.firstName, guest?.lastName]
      .map((part) => String(part || '').trim())
      .filter(Boolean)
      .join(' ');
  }

  guestInitials(guest: any): string {
    const first = String(guest?.firstName || '').trim();
    const last = String(guest?.lastName || '').trim();
    const initials = `${first.charAt(0)}${last.charAt(0)}`.trim();
    return (initials || first.slice(0, 2) || 'G').toUpperCase();
  }

  guestPhone(guest: any): string {
    const phone = String(guest?.phoneNo || guest?.phoneNumber || '').trim();
    if (!phone) {
      return '';
    }
    const code = String(guest?.callingCode || '').trim();
    return code ? `${code} ${phone}` : phone;
  }

  guestEmail(guest: any): string {
    return String(guest?.email || '').trim();
  }

  clearSearch() {
    this.searchQuery = '';
  }

  close() {
    this.modalController.dismiss();
  }

  selectGuest(guest: any) {
    this.modalController.dismiss({ ...guest });
  }
}
